import xworker from './worker/class.js';
import Hook from './worker/hook.js';

const XWorker = xworker();

export { Hook, XWorker };
